import { module } from 'modujs';
import VueProductRecommendations from '../vue/components/VueProductRecommendations';
import VueProductRecommendationsItem from '../vue/components/VueProductRecommendationsItem';
import ProductRecommendationsApi from "../classes/StorefrontApi/ProductRecommendationsApi/ProductRecommendationsApi";


export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$el = this.el
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        // Init vue
        this.initVue();
    }

    destroy() {
        super.destroy();
        this.app?.$destroy?.()
    }

    /////////////////////////
    // Vue Instance
    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Vue Components
        VueProductRecommendations(moduleInstance)
        VueProductRecommendationsItem(moduleInstance)

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el
        });
    }

    /////////////////////////
    // Data
    getProductRecommandations(productId) {
        return ProductRecommendationsApi.getProductRecommendations(productId)
    }
}
